'use client';

import ErrorPage from './(dashboard)/error';

export default function GlobalError(props: { error: Error }) {
  return <ErrorPage {...props} />;
}
